module.exports = __webpack_public_path__ + "static/media/id.e68e3639.svg";